import { FC, Suspense, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import Header from "../../components/ui/Header";
import useI18n from "../../hooks/useTranslations";
import { useModulesApi } from "../../http/useModules";
import { getEngineAdminSettings } from "../engines/registry";

const AdminModuleSettings: FC = () => {
  const i18n = useI18n();
  const { moduleId } = useParams<{ moduleId: string }>();
  const modulesApi = useModulesApi();
  const aborter = useRef(new AbortController());
  const moduleSwr = modulesApi.getAdminModuleSettings(moduleId!, aborter.current.signal);
  const moduleData = moduleSwr.data;

  useEffect(() => {
    moduleSwr.trigger();
  }, []);

  if (!moduleData && !moduleSwr.error) {
    return null;
  }

  const EngineSettings = getEngineAdminSettings(moduleId);

  return (
    <>
      <Header
        title={moduleData?.name ?? i18n.translation.common.loading}
        error={moduleSwr?.error}
        accentColor={moduleData?.category?.color}
        path={[
          { display: moduleData?.name ?? "", url: `/admin/modules/${moduleId}` },
          { display: i18n.translation.common.settings },
        ]}
      />
      {/* An engine's settings may be loaded on demand (lazy). */}
      {moduleData && EngineSettings && (
        <Suspense fallback={null}>
          <EngineSettings moduleData={moduleData} />
        </Suspense>
      )}
    </>
  );
};

export default AdminModuleSettings;
